export default {
  setRequests(state, payload) {
    state.requestsData = payload
  }
}